module.exports = __webpack_public_path__ + "img/buds3_band6.99aeee1d.png";